import React, { useState } from "react"
import { Box, Tabs, Tab } from "@mui/material"
import SiteWrapper from "./home-pages/SiteWrapper"
import TravelMapView from "./TravelMapView"
import TravelStats from "./TravelStats"
import { useTravelData } from "../hooks/useTravelData"
import { useFamilyTravelData } from "../hooks/useFamilyTravelData"
import { FAMILY_MEMBERS } from "../utils/userMapping"

function TabPanel({ children, value, index }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      style={{ flex: 1, height: "100%", overflow: "hidden" }}
    >
      {value === index && children}
    </div>
  )
}

function PersonTravelTab({ name }) {
  const { visitedUsa, visitedWorld, loading, togglePlace } = useTravelData(name)

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <TravelStats visitedUsa={visitedUsa} visitedWorld={visitedWorld} />
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <TravelMapView
          name={name}
          visitedUsa={visitedUsa}
          visitedWorld={visitedWorld}
          onToggle={togglePlace}
          loading={loading}
        />
      </Box>
    </Box>
  )
}

function FamilyTravelTab() {
  const { familyUsa, familyWorld, getVisitorsForPlace, loading } =
    useFamilyTravelData(true)

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <TravelStats visitedUsa={familyUsa} visitedWorld={familyWorld} />
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <TravelMapView
          name="Family"
          visitedUsa={familyUsa}
          visitedWorld={familyWorld}
          readOnly
          getTooltipExtra={getVisitorsForPlace}
          loading={loading}
          fillColor="#4caf50"
        />
      </Box>
    </Box>
  )
}

const TABS = [...FAMILY_MEMBERS, "Family"]

const TravelLog = () => {
  const [value, setValue] = useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <SiteWrapper>
      <Box
        sx={{
          height: "calc(100vh - 32px)",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Tabs value={value} onChange={handleChange} centered sx={{ borderBottom: 1, borderColor: "rgba(255,255,255,0.1)", '& .MuiTab-root': { color: 'rgba(255,255,255,0.5)', '&.Mui-selected': { color: '#fff' } } }}>
          {TABS.map((label) => (
            <Tab key={label} label={label} />
          ))}
        </Tabs>
        {FAMILY_MEMBERS.map((name, idx) => (
          <TabPanel key={name} value={value} index={idx}>
            <PersonTravelTab name={name} />
          </TabPanel>
        ))}
        <TabPanel value={value} index={FAMILY_MEMBERS.length}>
          <FamilyTravelTab />
        </TabPanel>
      </Box>
    </SiteWrapper>
  )
}

export default TravelLog
